import React from 'react';
import { LessonComponentStyleType } from '../../../models/LessonComponentStyleType';
import { TableComponent } from '../../../models/LessonComponent';
import { TableComponentEditor } from './TableComponentEditor';
import { TableComponentView } from './TableComponentView';
import { useLessonContext } from '../../../models/LessonContext';

interface TableProps {
  styleType: LessonComponentStyleType;
  component: TableComponent;
}
export const Table = (props: TableProps) => {
  const { mode } = useLessonContext();

  return mode === 'edit' ? (
    <TableComponentEditor {...props} />
  ) : (
    <TableComponentView {...props} />
  );
};
